module.exports = __webpack_public_path__ + "static/img/13.1631a93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/zh/13.png
// module id = 3FET
// module chunks = 0